var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.goodsissue")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("message.customer"),
                          subtitle: _vm.$t("series.gi") + " " + _vm.nextGiCode
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.storecompanyperson"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("selectize", {
                                  attrs: {
                                    default: _vm.form.defaultCustomerId,
                                    updateoption: _vm.form.updateOptionCustomer,
                                    options: _vm.form.optionCustomers,
                                    multiple: false,
                                    create: true,
                                    loading: _vm.form.loadingCustomer,
                                    validation:
                                      _vm.form.trickValidationCustomer,
                                    placeholder: _vm.$t(
                                      "placeholder.selectorcreate"
                                    )
                                  },
                                  on: { add: _vm.onAddedCustomer },
                                  model: {
                                    value: _vm.form.pickedCustomerId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "pickedCustomerId",
                                        $$v
                                      )
                                    },
                                    expression: "form.pickedCustomerId"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.form.pickedCustomerId
                        ? _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.address")))
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.customer.address,
                                        expression: "form.customer.address"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    staticStyle: { "min-height": "107px" },
                                    domProps: {
                                      value: _vm.form.customer.address
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.customer,
                                          "address",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.tel")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.customer.tel,
                                        expression: "form.customer.tel"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.customer.tel },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.customer,
                                          "tel",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.email")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.customer.email,
                                        expression: "form.customer.email"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.form.customer.email
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.customer,
                                          "email",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.date") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "apps.inventory.message.deliverydate"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("BaseInputDatePicker", {
                                  attrs: { mode: "dateTime", is24hr: "" },
                                  model: {
                                    value: _vm.form.selectedDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "selectedDate", $$v)
                                    },
                                    expression: "form.selectedDate"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("apps.inventory.message.pickfrom")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.store")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.pickedWarehouseId,
                                      expression: "form.pickedWarehouseId"
                                    }
                                  ],
                                  staticClass: "form-control custom-select",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.form,
                                        "pickedWarehouseId",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.warehouses, function(item, index) {
                                  return item.is_deleted == false
                                    ? _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: item.warehouse_id }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(item.warehouse_name) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              )
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.orderlist") }
                      }),
                      _vm._v(" "),
                      _vm.isRenderOrders
                        ? _c("OrderGI", {
                            attrs: {
                              validation: _vm.form.trickValidation,
                              data: _vm.form.orders,
                              createAble: true,
                              showProductImage: true,
                              selectedWhId: _vm.form.pickedWarehouseId,
                              optionBinLocations: _vm.optionBinLocations
                            },
                            on: { submit: _vm.onSubmitOrder }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("div", { staticClass: "col-md-12 no-padding" }, [
                    _c("div", { staticClass: "form-row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("placeholder.note")))
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.note,
                                  expression: "form.note"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                placeholder: _vm.$t("placeholder.dotted")
                              },
                              domProps: { value: _vm.form.note },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "note",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "action-bar" }, [
                  !_vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-web",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.form.trickValidation++
                                _vm.isCreateAnother = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.save")))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _vm._m(0)
                      ])
                    : _vm._e()
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3592c0e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3592c0e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/goodsissue/New.vue
// module id = null
// module chunks = 